@let participants = eventParticipants$ | async;
<section class="card p-4">
  <form [formGroup]="filtersForm" (ngSubmit)="applyFilters()" class="orders-filters">
    <div class="header">
      <h2 class="header__title">Pedidos</h2>
      <label class="orders-filters__search">
        Buscar pedido
        <input
          class="form-control"
          formControlName="search"
          placeholder="Nº do pedido, nome ou e-mail"
          maxlength="200" />
      </label>
    </div>
    <div class="orders-filters__grid">
      <label class="orders-filters__field"
        >Status
        <select class="form-select" formControlName="status">
          <option value="">Todos</option>
          <option value="paid">Pago</option>
          <option value="courtesy">Cortesia</option>
          <option value="refunded">Reembolsado</option>
        </select>
      </label>
      <label class="orders-filters__field"
        >Canal
        <select class="form-select" formControlName="sales_channel">
          <option value="">Todos</option>
          <option value="online">Venda Web</option>
          <option value="affiliate">Venda App Mobile</option>
          <option value="pdv">PDV Físico</option>
        </select>
      </label>
      <label class="orders-filters__field"
        >Meio de pagamento
        <select class="form-select" formControlName="payment_method">
          <option value="">Todos</option>
          <option value="cash">Dinheiro</option>
          <option value="credit_card">Crédito</option>
          <option value="debit">Débito</option>
          <option value="pix">PIX</option>
          <option value="complimentary">Gratuito / Cortesia</option>
        </select>
      </label>
      <div class="orders-filters__field">
        <label for="orders-paid-from">Data inicial da venda</label>
        <p-datepicker
          inputId="orders-paid-from"
          formControlName="paid_from"
          dateFormat="dd/mm/yy"
          placeholder="dd/mm/aaaa"
          [showIcon]="true"
          [readonlyInput]="true"
          [fluid]="true"
          [showButtonBar]="true"
          [maxDate]="filtersForm.controls.paid_until.value || undefined"
          appendTo="body" />
      </div>
      <div class="orders-filters__field">
        <label for="orders-paid-until">Data final da venda</label>
        <p-datepicker
          inputId="orders-paid-until"
          formControlName="paid_until"
          dateFormat="dd/mm/yy"
          placeholder="dd/mm/aaaa"
          [showIcon]="true"
          [readonlyInput]="true"
          [fluid]="true"
          [showButtonBar]="true"
          [minDate]="filtersForm.controls.paid_from.value || undefined"
          appendTo="body" />
      </div>
    </div>
    @if (validationError()) {
      <p role="alert" class="text-danger">{{ validationError() }}</p>
    }
    <div class="orders-filters__actions">
      <button type="submit" class="btn orders-filters__apply">Aplicar filtros</button>
      <button type="button" class="btn orders-filters__clear" (click)="clearFilters()">Limpar filtros</button>
    </div>
  </form>
  <div class="d-flex justify-content-end mb-3">
    <app-button (btnClick)="downloadReport()" styleType="outlined" icon="pi pi-download"
      >Baixar relatório completo</app-button
    >
  </div>
  @if (error()) {
    <p role="alert" class="text-danger">{{ error() }}</p>
  } @else {
    @if (ordersLoading()) {
      <p role="status">Carregando pedidos…</p>
    }
    <div class="table-container">
      <app-participants-table
        [data]="ordersLoading() ? null : participants"
        [first]="first"
        [rows]="rows"
        [sort]="sort"
        [direction]="direction"
        (detailOrderClick)="handleDetailOrder($event)"
        (pageChange)="handlePageChange($event)"
        (sortChange)="handleSort($event)" />
    </div>
  }
</section>

@if (loading) {
  <app-loading />
}
